// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Underline = function Underline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.438 1.25c.519 0 .937.418.937.938v9.062A5.626 5.626 0 0 0 10 16.875a5.626 5.626 0 0 0 5.625-5.625V2.188c0-.52.418-.938.938-.938.519 0 .937.418.937.938v9.062c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5V2.188c0-.52.418-.938.938-.938"
  }));
};
